import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import ConsumerBreadcrumb, { BreadcrumbPlaceholder } from './ConsumerBreadcrumb';
const ADMIN_PROPS = {
  config: {
    items: [{
      label: 'Home',
      link: '/shop'
    }, {
      label: 'Living Room Furniture',
      link: '/living-room-furniture/'
    }]
  },
  location: {
    pathname: '/',
    search: '',
    hash: '',
    state: {},
    key: 'is-admin-miomyf'
  },
  color: 'light',
  forPage: 'Home'
};
const ConsumerBreadcrumbWrapper = t0 => {
  const $ = _c(12);
  const {
    isAdmin: t1,
    config: t2,
    layout,
    color,
    forPage,
    withSchema: t3
  } = t0;
  const isAdmin = t1 === undefined ? false : t1;
  let t4;
  if ($[0] !== t2) {
    t4 = t2 === undefined ? {
      items: [],
      productVisualization: false
    } : t2;
    $[0] = t2;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const config = t4;
  const withSchema = t3 === undefined ? true : t3;
  const location = useLocation();
  let t5;
  if ($[2] !== color || $[3] !== config || $[4] !== forPage || $[5] !== isAdmin || $[6] !== layout || $[7] !== location || $[8] !== withSchema) {
    t5 = isAdmin ? ADMIN_PROPS : {
      config,
      location,
      layout,
      color,
      forPage,
      withSchema
    };
    $[2] = color;
    $[3] = config;
    $[4] = forPage;
    $[5] = isAdmin;
    $[6] = layout;
    $[7] = location;
    $[8] = withSchema;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const props = t5;
  let t6;
  if ($[10] !== props) {
    t6 = <ConsumerBreadcrumb {...props} />;
    $[10] = props;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
ConsumerBreadcrumbWrapper.propTypes = {
  isAdmin: PropTypes.bool,
  color: PropTypes.string,
  config: PropTypes.shape({
    categoryId: PropTypes.number,
    collectionId: PropTypes.number,
    items: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })),
    productId: PropTypes.number,
    productVisualization: PropTypes.bool,
    variantId: PropTypes.string
  }),
  forPage: PropTypes.string,
  layout: PropTypes.string,
  withSchema: PropTypes.bool
};
export { BreadcrumbPlaceholder };
export default ConsumerBreadcrumbWrapper;